import React from 'react';
import styles from './RecommendationItem.module.scss';

const RecommendationItem = ({item:{name, artist, href, uri, album: { images }}}) => {

  return (
    <div onClick={()=>window.location=uri} className={styles.recommendationItemContainer}>
        <div className={styles.image}>
          <div className={styles.imgContainer}>
            <img className={styles.album} src={images[0].url} alt={``}/>
          </div>
        </div>

        <div className={styles.text}>
          <h5 onClick={()=>window.location=uri}>{name}</h5>
          <h6 onClick={()=>window.location=artist.uri}>{artist.name}</h6>
        </div>
    </div>
  )

}

export default RecommendationItem;